import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { customerInteractionSchema } from "@common/components/helpers/validation-schemas/customerInteractionSchema";
import CustomerInteractionAction from "@common/redux/actions/CustomerInteractionAction";
import useCompliance from "./useCompliance";

const useCustomerInteraction = () => {
  const data = useSelector((state) =>
    CustomerInteractionAction.getStatePath(state),
  );
  const setState = CustomerInteractionAction.dispatch;

  const methods = useForm({
    resolver: yupResolver(customerInteractionSchema),
    defaultValues: data,
    mode: "all",
  });

  const { resetComplianceForms } = useCompliance(methods);

  const handleBack = () => resetComplianceForms();

  return {
    ...data,
    methods,
    handleBack,
    setState,
  };
};

export default useCustomerInteraction;
